export default __webpack_public_path__ + "static/La Playa Vol. 3 Homepage Banner Mobile - W4-b3dd13a0d1b23a98367646cda10484cb.webp";